











































































import { Component, Vue } from 'vue-property-decorator';
import {
    DeleteResultModel, RateRuleEditModel, RateRuleViewModel
} from '@/services/api/nswag/stapiclient_generated';
import RateRuleEdit from '@/views/RateRules/RateRuleEdit.vue';
import RateRuleItem from '@/views/RateRules/RateRuleItem.vue';
import {stRateRuleApi} from '@/services/st-api';
import {UserStore} from '@/store/user-module';

@Component({
    components: {
        RateRuleItem, RateRuleEdit
    },
})
export default class RateRules extends Vue {
    globalRule: RateRuleViewModel = RateRuleViewModel.fromJS({});
    newRule: RateRuleViewModel = RateRuleViewModel.fromJS({id: 0, editMode: false, editModel: null});

    mounted(){
        this.loadData();
    }

    get currency(){
        return UserStore.userSettings.currency;
    }

    get useRateRules(){
        return UserStore.userSettings.useRateRules;
    }

    async getNewRule(parentRateRule: RateRuleViewModel){
        this.newRule.editMode = true;
        this.newRule.editModel = (await stRateRuleApi.getNew(parentRateRule.id!));
    }

    async loadEditModel(rateRule: RateRuleViewModel) {
        let item: RateRuleEditModel = (await stRateRuleApi.get(rateRule.id!));

        rateRule.editMode = true;
        rateRule.editModel = item;
    }

    async submit(){
        const item = this.globalRule.editModel!;
        await stRateRuleApi.put(item.id, item);
        await this.loadData();
    }

    async loadData() {
        this.globalRule = (await stRateRuleApi.getRules());
    }
}
